import { render, staticRenderFns } from "./BikeInfoItem.vue?vue&type=template&id=1f161a40&"
import script from "./BikeInfoItem.vue?vue&type=script&lang=js&"
export * from "./BikeInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports